module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Keyboard-1ad05c8e4932a52e20dfed0a4c822554.svg";